import { FileText } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const TermsOfService = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="bg-gradient-to-b from-primary/20 to-background py-16">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center space-y-4">
            <FileText className="w-16 h-16 mx-auto text-primary" />
            <h1 className="text-4xl font-bold">Terms of Service</h1>
            <p className="text-xl text-muted-foreground">
              Please read these terms carefully before using our services
            </p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto space-y-8">
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">1. Agreement to Terms</h2>
            <p className="text-muted-foreground">
              By accessing or using Home Pros OKC's services, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access our services.
            </p>
          </section>

          <Separator />

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">2. Use of Services</h2>
            <p className="text-muted-foreground">
              Our platform connects homeowners with service professionals. We do not provide home services directly but facilitate connections between users and service providers.
            </p>
          </section>

          <Separator />

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">3. User Responsibilities</h2>
            <p className="text-muted-foreground">
              Users must provide accurate information when using our services and agree to maintain the confidentiality of any account information.
            </p>
          </section>

          <Separator />

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">4. Service Provider Listings</h2>
            <p className="text-muted-foreground">
              While we strive to verify all service providers, we cannot guarantee the quality of their work. Users should conduct their own due diligence before hiring any contractor.
            </p>
          </section>

          <Separator />

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold">5. Limitation of Liability</h2>
            <p className="text-muted-foreground">
              Home Pros OKC is not liable for any damages or losses resulting from the use of our services or any services provided by listed contractors.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;